// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavItem_wrapper__2a8i2","icon":"NavItem_icon__2rbGw","label":"NavItem_label__1dKZi"};